<!-- @format -->

<inquiry-tag>
<div class="container_breadcrumb">
  <ul class="breadcrumb">
    <li class="breadcrumb-item">
      <h1 class="heading-01 heading_skillsheet">お問い合わせ</h1>
    </li>
  </ul>
</div>
<!--/.container_breadcrumb-->
<div class="contents">
  <iframe src="{state.url}" style="width: 100%; height: 1300px; border: 0px"></iframe>
</div>
<script>
  import di from "dependeny-injection";
  export default {
    state: {
      url:null
    },
    onBeforeMount(props, state){
      this.api = di.createApi('menu');
      this.api.request('inquiry', 'fetch-inquiry-url')
      .then(data=>this.update({url: data}));
    }
  }
</script>
</inquiry-tag>
